import { ManagedSlot, ManagedBody } from "@/components/pages/ManagedPage";
import LongPage from "@/components/LongPage";
import PageStub from "@/components/PageStub";
import ContactForm from "@/components/Contact";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";
export { default as MonitoringOEE } from "@/pages/products/MonitoringOEE";
export { default as MES } from "@/pages/products/MES";
export { default as EnergyManagement } from "@/pages/products/EnergyManagement";
export { default as QualityManagement } from "@/pages/products/QualityManagement";
export { default as CMMS } from "@/pages/products/CMMS";
export { default as Workspace } from "@/pages/products/Workspace";
export { default as Platform } from "@/pages/PlatformPage";
export { default as Integrations } from "@/pages/IntegrationsPage";

const productsCrumb = [{ name: "Products", to: "/#modules" }];
const industriesCrumb = [{ name: "Industries", to: "/industries" }];

// /contact and /get-started render the identical page (same form, same copy),
// so both declare /contact (in the current language) as canonical; /get-started
// keeps working for CTAs and tracking but is excluded from the sitemap.
export const Contact = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        path="/contact"
        title={t("Contact BEEDIGIT — Book a Factory Assessment or Demo")}
        description={t("Talk to a BEEDIGIT expert: book a factory visibility assessment, baseline OEE, downtime and energy losses, and plan ERP/IIoT integration.")}
      />
      <Navigation />
      <ManagedSlot at="start" />
      <ManagedBody>
      <main className="flex-1 pt-14">
        <ContactForm id="contact" asPageTitle />
      </main>
      </ManagedBody>
      <ManagedSlot at="end" />
      <Footer />
    </div>
  );
};

export const CableWire = () => (
  <LongPage
    breadcrumb={industriesCrumb}
    eyebrow="Industry · Cable & Wire"
    title="MES for cable and wire manufacturing"
    description="Length + Speed + Reset as the minimum signal baseline. Process drums, SFG/FG batches, traceability, and energy per useful meter."
    bullets={["Length-based OEE for drawing and extrusion","Process drums and SFG/FG batch genealogy","QR traceability from drum to delivery","Energy per useful meter, not just kWh"]}
    sections={[
      { kind: "features", eyebrow: "Industry fit", heading: "Built around cable & wire realities", cols: 2,
        items: [
          { title: "Length-based output", desc: "Pulses from the line drive output and OEE in meters, not just pieces." },
          { title: "Process drums", desc: "Track drums as in-process inventory across machines." },
          { title: "SFG and FG batches", desc: "Genealogy from raw inputs to delivered cable." },
          { title: "Energy per meter", desc: "Specific energy per useful output, normalized to product." },
        ],
      },
      { kind: "checklist", eyebrow: "Use cases", heading: "Common scenarios we solve",
        items: [
          "Drawing, stranding, extrusion, cabling",
          "Length reconciliation across stages",
          "Scrap and rework attribution",
          "Energy cost per kilometer of finished cable",
          "Customer-facing traceability records",
          "ISO 50001 evidence from real production",
        ],
      },
    ]}
  />
);

export { GlossaryIndex, GlossaryTerm } from "@/pages/Glossary";